import { combineReducers } from "redux";
import clinicReducer from "./clinicReducer";
import companyReducer from "./companyReducer";
import doctorReducer from "./doctorReducer";
import userReducer from "./userReducer";
import departmentReducer from "./departmentReducer";
import patientReducer from "./patientReducer";
import scheduleMedicalReducer from "./scheduleMedicalReducer";
import patientResultReducer from "./patientResultReducer";
import servicePriceReducer from "./servicePriceReducer";
import medicineReducer from "./medicineReducer";
import enterpriseReducer from "./enterpriseReducer";
import systemSettingReducer from "./systemSettingReducer";
import paymentReducer from "./paymentReducer";
import userLogReducer from "./userLogReducer";

export default combineReducers({ 
    clinic: clinicReducer, 
    company: companyReducer,
    user: userReducer,
    doctor: doctorReducer,
    department: departmentReducer,
    patient: patientReducer,
    scheduleMedical: scheduleMedicalReducer,
    patientResult: patientResultReducer,
    servicePrice: servicePriceReducer,
    medicine: medicineReducer,
    enterprise: enterpriseReducer,
    systemSetting: systemSettingReducer,
    payment: paymentReducer,
    userLog: userLogReducer
});